import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
// components
import Dropdown from 'react-bootstrap/Dropdown';
import HeaderGlobal from './HeaderGlobal';
import HeaderDropdown from './HeaderDropdown';
import Image from '../image/Image';
import CustomLink from '../custom-link/CustomLink';
import SearchForm from '../search-form/SearchForm';
import { sharedLogosPath } from '../../scripts/data';
// data
import menus from './header-content';
var HeaderFull = /*#__PURE__*/function (_React$Component) {
  function HeaderFull(props) {
    var _this;
    _classCallCheck(this, HeaderFull);
    _this = _callSuper(this, HeaderFull, [props]);
    _defineProperty(_this, "handleNavToggleClick", function () {
      _this.closeAllNavDropdowns();
      _this.setState(function () {
        return {
          mobSubMenu: false
        };
      });
      _this.setState(function (prevState) {
        return {
          isMobileToggleOn: !prevState.isMobileToggleOn
        };
      });
    });
    _defineProperty(_this, "checkOverlay", function () {
      var state = false;
      menus.forEach(function (st) {
        var id = st.id;
        if (_this.state[id]) {
          state = true;
        }
      });
      return state;
    });
    _defineProperty(_this, "setToggleDropdown", function (state) {
      _this.setState(function (prevState) {
        return {
          mobSubMenu: !prevState[state]
        };
      });
      _this.setState(function (prevState) {
        return _defineProperty({}, state, !prevState[state]);
      }, function () {
        _this.showOverlay(_this.checkOverlay());
      });
      // to close search dropdown on desktop if open
      if (_this.state.searchDrp) {
        _this.setState(function () {
          return {
            searchDrp: false
          };
        });
      }
    });
    _this.state = {
      isMobileToggleOn: false,
      showOverlay: false,
      mobSubMenu: false,
      rpt: false,
      itp: false,
      crd: false,
      lns: false,
      aut: false,
      mon: false,
      searchDrp: false
    };
    return _this;
  }
  _inherits(HeaderFull, _React$Component);
  return _createClass(HeaderFull, [{
    key: "closeAllNavDropdowns",
    value: function closeAllNavDropdowns(id) {
      var _this2 = this;
      if (!id) {
        this.showOverlay(false);
      }
      menus.forEach(function (st) {
        if (!id || st.id !== id) {
          _this2.setState(_defineProperty({}, st.id, false));
        }
      });
    }
  }, {
    key: "showOverlay",
    value: function showOverlay(statement) {
      this.setState(function () {
        return {
          showOverlay: statement
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        id: "nav-overlay",
        className: "".concat(this.state.showOverlay ? 'overlay' : '')
      }), React.createElement("header", {
        id: "header",
        className: "".concat(this.state.isMobileToggleOn ? 'mob-open' : '', " ").concat(this.state.mobSubMenu ? 'mob-sub-open' : '')
      }, React.createElement("div", {
        className: "container d-flex justify-content-between align-items-center nav-mobile d-lg-none py-2"
      }, React.createElement(CustomLink, {
        isLink: this.props.pageType === 'product',
        href: "/",
        className: "exp-logo"
      }, React.createElement(Image, {
        src: "".concat(sharedLogosPath, "/logo-experian.svg"),
        alt: "Experian logo.",
        width: "111",
        height: "38",
        fetchPriority: "high"
      })), React.createElement("div", null, React.createElement("a", {
        href: "/help/login.html",
        "data-link-both": "nav-public-header-signin"
      }, "Sign In"), React.createElement("button", {
        type: "button",
        "aria-label": "Open menu",
        className: "btn nav-toggle ecs-font-icon-nav-menu py-0 pe-0",
        "aria-expanded": "false",
        "aria-controls": "nav-full",
        "aria-haspopup": "true",
        "data-link-both": "nav-public-header-menudropdownopen",
        onClick: this.handleNavToggleClick
      }))), React.createElement("nav", {
        id: "nav-full",
        className: "d-flex flex-lg-wrap flex-column flex-lg-row align-items-start"
      }, React.createElement("div", {
        className: "container justify-content-between mobile-top-search order-1 py-3 border-bottom d-lg-none w-100 align-self-start align-self-lg-baseline align-items-start"
      }, React.createElement("button", {
        type: "button",
        className: "nav-toggle btn order-2 ecs-font-icon-act-close py-0 pe-0",
        "aria-controls": "nav-full",
        "aria-label": "Close menu",
        "aria-expanded": "true",
        "aria-haspopup": "true",
        "data-link-both": "nav-public-header-menudropdownclose",
        onClick: this.handleNavToggleClick
      }), React.createElement(SearchForm, {
        toShowCopyOnFocus: true,
        ifFocusableOnLoad: false,
        className: "rounded-2 order-1 flex-fill w-100",
        id: "nav-full-search",
        homepage: this.props.homepage
      })), React.createElement("div", {
        id: "main-navigation",
        className: "w-100 align-self-lg-baseline order-2"
      }, React.createElement("div", {
        className: "container"
      }, React.createElement("div", {
        className: "col d-lg-flex justify-content-lg-between align-items-lg-center position-relative"
      }, React.createElement("div", {
        className: "d-lg-flex align-items-lg-center"
      }, React.createElement(CustomLink, {
        isLink: this.props.pageType === 'product',
        className: "me-lg-4 exp-logo",
        href: "/"
      }, React.createElement(Image, {
        src: "".concat(sharedLogosPath, "/logo-experian.svg"),
        alt: "Experian logo.",
        width: "145",
        height: "49",
        fetchPriority: "high"
      })), React.createElement("ul", {
        className: "main-nav-1 d-flex flex-wrap flex-lg-nowrap mb-0 ps-0"
      }, menus.map(function (menu) {
        return React.createElement("li", {
          key: "header-".concat(menu.id, "-li")
        }, React.createElement(Dropdown, {
          show: _this3.state[menu.id],
          autoClose: "outside",
          className: "position-static",
          focusFirstItemOnShow: "keyboard",
          onToggle: function onToggle() {
            _this3.setToggleDropdown(menu.id);
          }
        }, React.createElement(Dropdown.Toggle, {
          as: "button",
          id: menu.id,
          type: "button",
          "aria-haspopup": "true",
          "aria-label": menu.tabName,
          className: "".concat(_this3.state[menu.id] ? 'active-link' : '', " m-n-link btn-reset"),
          onClick: function onClick() {
            _this3.setToggleDropdown(menu.id);
          },
          "data-link-both": menu.dataLinkBoth
        }, menu.tabName), React.createElement(Dropdown.Menu, {
          align: {
            lg: 'end'
          },
          renderOnMount: true,
          "aria-labelledby": menu.id
        }, React.createElement(HeaderDropdown, {
          pageType: _this3.props.pageType,
          menu: menu,
          backToMenu: _this3.setToggleDropdown
        }))));
      }))), React.createElement("div", {
        className: "main-nav-2 d-none d-lg-flex align-items-lg-center"
      }, React.createElement("a", {
        href: "/help/login.html",
        "data-link-both": "nav-public-header-signin",
        className: "login"
      }, "Sign In"), React.createElement(Dropdown, {
        autoClose: "outside",
        show: this.state.searchDrp,
        onToggle: function onToggle() {
          _this3.setState(function (prevState) {
            return {
              searchDrp: !prevState.searchDrp
            };
          });
        }
      }, React.createElement(Dropdown.Toggle, {
        variant: "button",
        id: "header-search-toggle",
        "aria-haspopup": "true",
        "aria-label": "Search.",
        className: "m-0 p-0 text-decoration-none search-btn"
      }), React.createElement(Dropdown.Menu, {
        align: {
          lg: 'end'
        },
        className: "mt-3",
        "aria-labelledby": "header-search-toggle"
      }, React.createElement(SearchForm, {
        toShowCopyOnFocus: false,
        ifFocusableOnLoad: true,
        id: "nav-drp-search",
        homepage: this.props.homepage
      }))))))), React.createElement(HeaderGlobal, {
        homepage: this.props.homepage,
        pageType: this.props.pageType
      }))));
    }
  }]);
}(React.Component);
export { HeaderFull as default };